var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"theme4-gallery"},[_c('theme4-gallery-component'),_c('theme-changer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }